import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { HOME_SECTIONS } from "@/constants/testIds";
import GoldButton from "../site/GoldButton";
import { BRAND } from "@/lib/data";

export default function CTASection() {
  const { t } = useTranslation();
  return (
    <section
      data-testid={HOME_SECTIONS.cta}
      className="relative overflow-hidden bg-ink-950 py-32 lg:py-48"
    >
      {/* Ambient gold glow */}
      <div
        className="pointer-events-none absolute inset-0 opacity-70"
        aria-hidden
        style={{
          background:
            "radial-gradient(600px circle at 50% 60%, rgba(212,175,55,0.18), transparent 60%)",
        }}
      />

      <div className="relative mx-auto max-w-[1440px] px-6 text-center lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mx-auto flex max-w-max items-center gap-3 font-sans text-[11px] uppercase tracking-widest text-gold"
        >
          <span className="h-px w-8 bg-gold" />
          {t("cta.eyebrow")}
          <span className="h-px w-8 bg-gold" />
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
          className="mx-auto mt-8 max-w-5xl font-display text-5xl leading-[0.98] tracking-tightest text-ivory lg:text-8xl xl:text-[8rem]"
        >
          {t("cta.title1")}<br />
          <span className="italic text-gold">{t("cta.title2")}</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="mx-auto mt-10 max-w-xl font-sans text-base text-ivory-soft lg:text-lg"
        >
          {t("cta.subline")}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="mt-12 flex flex-wrap items-center justify-center gap-4"
        >
          <GoldButton to="/contact" variant="gold">
            {t("cta.start")}
          </GoldButton>
          <GoldButton
            as="a"
            href={BRAND.phoneHref}
            variant="line"
          >
            {t("cta.call", { phone: BRAND.phone })}
          </GoldButton>
          <GoldButton
            as="a"
            href={BRAND.meetingHref}
            variant="ghost"
          >
            {t("cta.book")}
          </GoldButton>
        </motion.div>
      </div>
    </section>
  );
}
